<template>

<!-- Created with Inkscape (http://www.inkscape.org/) -->

<svg
   version="1.1"
   id="svg1350"
   xml:space="preserve"
   width="682.66669"
   height="682.66669"
   viewBox="0 0 682.66669 682.66669"
   xmlns="http://www.w3.org/2000/svg"
   xmlns:svg="http://www.w3.org/2000/svg"><defs
     id="defs1354"><clipPath
       clipPathUnits="userSpaceOnUse"
       id="clipPath1364"><path
         d="M 0,512 H 512 V 0 H 0 Z"
         id="path1362" /></clipPath></defs><g
     id="g1356"
     transform="matrix(1.3333333,0,0,-1.3333333,0,682.66667)"><g
       id="g1358"><g
         id="g1360"
         clip-path="url(#clipPath1364)"><g
           id="g1366"
           transform="translate(504.5,115.5001)"><path
             d="m 0,0 v -20 c 0,-22.092 -17.909,-40 -40,-40 h -188.5 c -11.046,0 -20,8.954 -20,20 v 29"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path1368" /></g><g
           id="g1370"
           transform="translate(476,411.5)"><path
             d="m 0,0 h 13.5 c 8.284,0 15,-6.716 15,-15 v -246"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path1372" /></g><g
           id="g1374"
           transform="translate(36,411.5)"><path
             d="m 0,0 h -13.5 c -8.284,0 -15,-6.716 -15,-15 v -301 c 0,-22.091 17.909,-40 40,-40 H 200 c 11.046,0 20,8.954 20,20 v 27.5"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path1376" /></g><g
           id="g1378"
           transform="translate(172.5,441.5)"><path
             d="m 0,0 h 68.5 c 8.284,0 15,-6.716 15,-15 v -326.072 c 0,-8.284 -6.716,-15 -15,-15 H -120 c -8.284,0 -15,6.716 -15,15 V -15 c 0,8.284 6.716,15 15,15 h 29.25"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path1380" /></g><g
           id="g1382"
           transform="translate(256,426.5)"><path
             d="m 0,0 c 0,8.284 6.716,15 15,15 h 188.5 c 8.284,0 15,-6.716 15,-15 v -326.072 c 0,-8.284 -6.716,-15 -15,-15 H 15 c -8.284,0 -15,6.716 -15,15"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path1384" /></g><g
           id="g1386"
           transform="translate(129.2123,369.7329)"><path
             d="m 0,0 -15.925,13.898 c -1.883,1.644 -4.691,1.644 -6.575,0 L -38.425,0 c -3.234,-2.823 -8.287,-0.526 -8.287,3.767 v 78 c 0,2.762 2.238,5 5,5 h 45 c 2.761,0 5,-2.238 5,-5 v -78 C 8.288,-0.526 3.234,-2.823 0,0 Z"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path1388" /></g><g
           id="g1390"
           transform="translate(395.6378,303.0711)"><path
             d="m 0,0 11.314,11.314 c 5.858,5.858 5.858,15.355 0,21.213 v 0 c -5.858,5.858 -15.356,5.858 -21.214,0 L -21.213,21.213 c -3.905,-3.905 -10.237,-3.905 -14.142,0 l -12.021,12.021 c -5.858,5.858 -15.356,5.858 -21.213,0 v 0 c -5.858,-5.858 -5.858,-15.355 0,-21.213 L -56.569,0 c 3.906,-3.905 3.906,-10.237 0,-14.142 l -12.02,-12.021 c -5.858,-5.858 -5.858,-15.355 0,-21.213 v 0 c 5.857,-5.858 15.355,-5.858 21.213,0 l 12.021,12.021 c 3.905,3.905 10.237,3.905 14.142,0 L -9.9,-46.669 c 5.858,-5.858 15.356,-5.858 21.214,0 v 0 c 5.858,5.858 5.858,15.355 0,21.213 L 0,-14.142 C -3.905,-10.237 -3.905,-3.905 0,0 Z"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path1392" /></g><g
           id="g1394"
           transform="translate(112.3518,306.9602)"><path
             d="m 0,0 16.263,-16.263 c 1.953,-1.953 5.119,-1.953 7.072,0 l 45.961,45.961 c 5.858,5.858 15.356,5.858 21.214,0 v 0 c 5.858,-5.857 5.858,-15.355 0,-21.213 L 30.406,-51.619 c -5.858,-5.858 -15.356,-5.858 -21.214,0 l -30.405,30.406 c -5.858,5.858 -5.858,15.355 0,21.213 V 0 C -15.355,5.858 -5.858,5.858 0,0 Z"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path1396" /></g><g
           id="g1398"
           transform="translate(245,399.5)"><path
             d="M 0,0 H 23"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path1400" /></g><g
           id="g1402"
           transform="translate(244,345.5)"><path
             d="M 0,0 H 23"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path1404" /></g><g
           id="g1406"
           transform="translate(244,290.5)"><path
             d="M 0,0 H 23"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path1408" /></g><g
           id="g1410"
           transform="translate(244,235.5)"><path
             d="M 0,0 H 23"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path1412" /></g><g
           id="g1414"
           transform="translate(244,180.5)"><path
             d="M 0,0 H 23"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path1416" /></g><g
           id="g1418"
           transform="translate(244,125.5)"><path
             d="M 0,0 H 23"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path1420" /></g><g
           id="g1422"
           transform="translate(97,210.5)"><path
             d="M 0,0 H 100"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path1424" /></g><g
           id="g1426"
           transform="translate(117,180.5)"><path
             d="M 0,0 H 60"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path1428" /></g><g
           id="g1430"
           transform="translate(317,210.5)"><path
             d="M 0,0 H 100"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path1432" /></g><g
           id="g1434"
           transform="translate(337,180.5)"><path
             d="M 0,0 H 60"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path1436" /></g></g></g></g></svg>
</template>
